import styled from "styled-components";
import Line from "features/trades/TradeDrawer/Timeline/Line";
import useMedia from "utils/hooks/useMedia.js";
import { MOBILE_SEARCH } from "common/constants.js";

interface PointAndLineProps {
  color: string;
}

const PointAndLine = ({ color }: PointAndLineProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  return (
    <Line
      $horizontal={true}
      $length={isMobile ? 20 : 35}
      style={{ minWidth: isMobile ? 20 : 35 }}
    >
      <Point $color={color} />
    </Line>
  );
};

export default PointAndLine;

const Point = styled.div<{ $color: string }>`
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.layoutBgColor};
  height: 14px;
  width: 14px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 3px solid ${(p) => p.$color};
`;
